import { FormRangeDateModel } from './form-range-date';
import { RANGE_SLIDER_MAX_VALUE, RANGE_SLIDER_MIN_VALUE, RangeSliderValue } from './range-slider';

export class FormRangeDateUtils {
    /**
     * Sucht für allernächsten Index im range-array
     * Kommt -1 zurück wenn range leer ist
     */
    static findClosestIndex(goal: number, range: number[]): number {
        return range.reduce((prev: { key: number, value: number }, curr: number, key: number) => {
            if (isNaN(prev.value) || Math.abs(curr - goal) < Math.abs(prev.value - goal)) {
                return { key, value: curr };
            }
            return prev;
        }, { key: -1, value: NaN }).key;
    }

    /**
     * Model validieren und vorbereiten
     * @param value
     * @param minExtreme
     * @param maxExtreme
     * @returns {{from: Date, to: Date}}
     */
    static prepareModel(value: FormRangeDateModel, minExtreme: Date, maxExtreme: Date): FormRangeDateModel {
        let from = value.from || minExtreme;
        if (from.getTime() < minExtreme.getTime()) {
            from = minExtreme;
        }
        if (from.getTime() > maxExtreme.getTime()) {
            from = maxExtreme;
        }
        let to = value.to || maxExtreme;
        if (to.getTime() > maxExtreme.getTime()) {
            to = maxExtreme;
        }
        if (to.getTime() < minExtreme.getTime()) {
            to = minExtreme;
        }

        return { from, to };
    }

    static dateToSliderValue(model: FormRangeDateModel, range: Date[]): RangeSliderValue {
        const numberRange = range.map(x => x.getTime());
        let indexFrom = FormRangeDateUtils.findClosestIndex(model.from.getTime(), numberRange);
        if (indexFrom === -1) {
            indexFrom = 0;
        }

        let indexTo = FormRangeDateUtils.findClosestIndex(model.to.getTime(), numberRange);
        if (indexTo === -1) {
            indexTo = range.length - 1;
        }

        const from = Math.round(indexFrom / (range.length - 1) * RANGE_SLIDER_MAX_VALUE);
        const to = Math.round(indexTo / (range.length - 1) * RANGE_SLIDER_MAX_VALUE);

        return {
            from: isNaN(from) ? RANGE_SLIDER_MIN_VALUE : from,
            to: isNaN(to) ? RANGE_SLIDER_MAX_VALUE : to
        };
    }

    /**
     * Tranformiert die Werte vom Schieberegler nach folgenden Daten im "range"
     */
    static sliderValueToDate(value: RangeSliderValue, range: Date[]): FormRangeDateModel {
        const indexFrom = Math.round((range.length - 1) / RANGE_SLIDER_MAX_VALUE * value.from);
        const indexTo = Math.round((range.length - 1) / RANGE_SLIDER_MAX_VALUE * value.to);

        return {
            from: range[indexFrom],
            to: range[indexTo]
        };
    }
}
